import { render, staticRenderFns } from "./auth-button.vue?vue&type=template&id=2baf7d7c&scoped=true"
import script from "./auth-button.vue?vue&type=script&lang=js"
export * from "./auth-button.vue?vue&type=script&lang=js"
import style0 from "./auth-button.vue?vue&type=style&index=0&id=2baf7d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf7d7c",
  null
  
)

export default component.exports